import React from "react"
import "../css/resource.css"
import { Link, useStaticQuery } from "gatsby"

class SimpleSlide extends React.Component {
  constructor(props) {
    super(props)
  }

 

  render() {
    return (
  null
    )
  }
}

export default SimpleSlide
